<template>
    <div>
        <div class="inner-header">
            <nav class="navbar fixed-top animate__animated animate__slideInRight">
                <a @click="$router.go(-1)" class="back-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                        <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                            <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none"
                                stroke="#000" stroke-width="2" />
                            <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                                transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                        </g>
                    </svg>
                </a>
                <a href="" class="link-title">Initiation Details</a>
            </nav>
        </div>
        <div class="inner-page animate__animated animate__slideInRight">
            <div class="container-fluid">
                <div class="row">
                    <!-- Enquiry Card -->
                    <div class="col-12">
                        <div class="card details-card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-7">
                                        <span class="lead-title" v-if="GetBrokerInitiationDetails.name">{{GetBrokerInitiationDetails.name}}</span>
                                        <span class="sub-title" v-if="GetBrokerInitiationDetails.firm_name">{{GetBrokerInitiationDetails.firm_name}}</span>
                                    </div>
                                    <div class="col-5 text-right">
                                      <!-- <span class="enq-title d-block">Status</span> -->
                                      <span class="label-status" v-if="GetBrokerInitiationDetails.status">{{GetBrokerInitiationDetails.status}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <span class="enq-title">Assigned to</span>
                                        <span class="enq-details" v-if="GetBrokerInitiationDetails.assigned_to">{{GetBrokerInitiationDetails.assigned_to}}</span>
                                    </div>
                                    <div class="col-6" v-if="GetBrokerInitiationDetails.locality">
                                        <span class="enq-title">Locality</span>
                                        <span class="enq-details">{{GetBrokerInitiationDetails.locality}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                      <span class="enq-title">NCD</span>
                                      <span class="enq-details" v-if="GetBrokerInitiationDetails.ncd">{{GetBrokerInitiationDetails.ncd}}</span>
                                  </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" v-if="GetBrokerInitiationDetails.comment">
                                        <span class="enq-title">Description</span>
                                         <read-more more-str="read more"  :text="GetBrokerInitiationDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="row">
                                    <div class="col-6 text-center">
                                       <a v-if="GetBrokerInitiationDetails.contact_number" :href="`tel:${GetBrokerInitiationDetails.contact_number}`">
                                        <span class="icon icon-call">
                                            <img src="@/assets/phone.svg" alt="" />
                                        </span>
                                        <span class="enq-title">Mobile Number</span>
                                        <span class="enq-details">{{GetBrokerInitiationDetails.contact_number}}</span>
                                       </a>
                                    </div>
                                    <div class="col-6 text-center">
                                      <a v-if="GetBrokerInitiationDetails.email" :href="`mailto:${GetBrokerInitiationDetails.email}`">
                                        <span class="icon icon-call">
                                            <img src="@/assets/email.svg" alt="" />
                                        </span>
                                        <span class="enq-title">Primary Email</span>
                                        <span class="enq-details">{{GetBrokerInitiationDetails.email}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-btn">
                            <div class="row">
                                <div class="col-12 mt-3 mb-3">
                                    <span class="info-text text-center" v-if="GetBrokerInitiationDetails.building_name">{{GetBrokerInitiationDetails.building_name}}</span>
                                    <button class="btn btn-primary btn-block" @click="initiate = true">Edit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vue-bottom-dialog v-model="initiate" :height="570">
            <div class="card form-card p-0">
                <div class="card-body pt-0 pb-0">
                    <div class="row">
                        <div class="col-8">
                            <span class="title-bottom">Broker Initiation</span>
                        </div>
                        <div class="col-4 text-right">
                            <span class="title-bottom title-cancel"  @click="clearInitiateForm">Cancel</span>
                        </div>
                    </div>
                    <b-form class="pb-0" @submit.prevent="UpdateBrokers">
                        <b-form-group>
                          <label>NCD<span class="text-danger">*</span></label>
                            <datetime type="datetime" v-model="UpdateBrokersDetails.next_call_date" required placeholder="Next Call Date and Time">
                            </datetime>
                        </b-form-group>
                        <b-form-group>
                            <label>Assign to<span class="text-danger">*</span></label>
                            <multiselect v-model="userSelected" :searchable="true" placeholder="Select Assign To" label="text" class="form-multiselect" ref="userselect" track-by="value" :options="GetassignedTo" :multiple="false" :taggable="false" @input="selectAssignTo"></multiselect>
                        </b-form-group>
                        <b-form-group>
                            <label>Select Status<span class="text-danger">*</span></label>
                            <b-form-select v-model="UpdateBrokersDetails.status_id" :options="statusList" required></b-form-select>
                        </b-form-group>
                        <b-form-group>
                            <label>Comment<span class="text-danger">*</span></label>
                            <b-form-textarea placeholder="Add Comment" v-model="UpdateBrokersDetails.comment" required rows="3" max-rows="5"></b-form-textarea>
                        </b-form-group>
                        <b-form-group class="mt-2">
                            <b-button variant="primary" type="submit" block>Save</b-button>
                        </b-form-group>
                    </b-form>
                </div>

            </div>
        </vue-bottom-dialog>
    </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'

export default {
  components: {
      datetime: Datetime,
      Multiselect
  },
  name: "InitiationDetails",
  data() {
    return {
      initiate: false,
      queryP: {},
      BuildingId: '',
      GetassignedTo: [],
      GetBrokerInitiationDetails: {},
      Brokerid: '',
      userSelected:{
        value:null,
        text:'Select Assign To'
      },
      UpdateBrokersDetails: {
        user_id: null,
        status_id: null,
        next_call_date: null,
        comment: null
      },
    };
  },
  created() {
    this.FetchBrokerInitiationDetails();
    this.selectAssignTo();
  },
  computed: {
    statusList() {
      return this.$store.getters.statusesMaster;
    },
  },
  methods: {
    FetchBrokerInitiationDetails() {
      this.queryP['id'] = this.$route.params.id;
      this.queryP['broker_id'] = this.$route.params.brokerid;
      this.$axios.get(`/buildings/broker_detail`, { params: this.queryP }).then((res) => {
      this.GetBrokerInitiationDetails = JSON.parse(JSON.stringify(res.data.broker).substring(1, JSON.stringify(res.data.broker).length-1));
      this.FetchAssignedTo()
      });
    },
    FetchAssignedTo() {
      this.GetassignedTo = []
      let searchDataUrl = new URLSearchParams({
        id: this.queryP.id
      }).toString();
      this.$axios.get(`buildings/broker_users?${searchDataUrl}`)
      .then(res => {
        res.data.assigned_to.forEach((item,index) => {
          this.GetassignedTo.push({value: item.id, text: item.name})
        });
      })
      .catch(err => console.log(err.response))
    },
    UpdateBrokers () {
      this.UpdateBrokersDetails['building_id'] = this.GetBrokerInitiationDetails.building_id
      this.UpdateBrokersDetails['broker_id'] = this.GetBrokerInitiationDetails.broker_id
      this.UpdateBrokersDetails['user_id'] = this.userSelected && this.userSelected.value;
      this.$axios
      .put(`buildings/main_brokers`,{ buildings_main_brokers: this.UpdateBrokersDetails })
      .then((res) => {
        swal({
          title: "Broker Updated!",
          icon: "success",
        }).then(()=>{
          this.clearInitiateForm();
          this.FetchBrokerInitiationDetails();
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error",
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error",
          });
        }
      });
    },
    clearInitiateForm(){
      this.UpdateBrokersDetails = {};
      this.UpdateBrokersDetails.status_id = null;
      this.userSelected={
          value:null,
          text:'Select Assign To'
      }; 
      this.selectAssignTo();
      this.initiate = false;

    },
    selectAssignTo(){
      this.$nextTick(()=> {
        if(this.$refs.userselect){
          this.$refs.userselect.$el.querySelector('input').required = !this.userSelected || !this.userSelected.value;    
        }
      });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .inner-page {
        margin-top: 60px;
    }
</style>